<form [formGroup]="formGroup" class="gw-flex gw-flex-col gw-gap-x-large">
  <div
    class="gw-grid gw-grid-cols-1 lg:gw-grid-cols-2 gw-gap-x-medium gw-gap-y-x-large"
  >
    <gatewee-select-v3
      id="estimatedMonthlyVolume"
      [label]="
        'features.onboarding.estimatedVolumesForm.labels.monthlyVolume'
          | translate
      "
      [items]="monthlyRevenueOptions"
      formControlName="estimatedMonthlyVolume"
      [placeholder]="
        'features.onboarding.estimatedVolumesForm.placeholders.select'
          | translate
      "
      [required]="true"
    ></gatewee-select-v3>
    <gatewee-select-v3
      id="estimatedAverageTicket"
      [label]="
        'features.onboarding.estimatedVolumesForm.labels.averageTicket'
          | translate
      "
      [items]="averageTicketOptions"
      formControlName="estimatedAverageTicket"
      [placeholder]="
        'features.onboarding.estimatedVolumesForm.placeholders.select'
          | translate
      "
      [required]="true"
    ></gatewee-select-v3>
  </div>

  <gatewee-input-v2
    *ngIf="!formGroup.get('noWebsite')?.value"
    [form]="formGroup"
    controlName="website"
    [label]="
      'features.onboarding.estimatedVolumesForm.labels.website' | translate
    "
    type="text"
    id="estimated-volumes-website"
  ></gatewee-input-v2>

  <div class="gw-flex gw-items-center">
    <gatewee-checkbox
      formControlName="noWebsite"
      [label]="
        'features.onboarding.estimatedVolumesForm.labels.noWebsite' | translate
      "
    ></gatewee-checkbox>
  </div>
</form>
